import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBygisznYOA9xMR4Pf2uCT9Vf2HzcgdRW0",
  authDomain: "customradarchart.firebaseapp.com",
  projectId: "customradarchart",
  storageBucket: "customradarchart.firebasestorage.app",
  messagingSenderId: "391476109266",
  appId: "1:391476109266:web:c7d6c1aeb467150a90720b",
  measurementId: "G-HXLPPMN7XG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);